import React, { useMemo } from "react";
import { Button, TextField } from "@mui/material";
import {
  Add as AddIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
} from "@mui/icons-material";
import { toast } from "react-toastify";
import {
  convertPresetsToDb,
  isTimeOverlapping,
  handleAddSchedule,
} from "./utils";
import TimeSlotList from "./TimeSlotList";
import * as S from "./styles";

function EditPresetForm({
  editingPreset,
  setEditingPreset,
  editMutation,
  group_code,
  project_code,
  shiftsData,
}) {
  const preparedPreset = useMemo(() => {
    if (!editingPreset) return editingPreset;
    return {
      ...editingPreset,
      schedules: editingPreset.schedules.map((s) => {
        const end = s.end;
        const isMidnight = end === 1440 || end === "24:00" || end === "00:00";
        return {
          ...s,
          isUntilMidnight: isMidnight,
        };
      }),
    };
  }, [editingPreset]);
  const setPresetFromTimeSlot = (updater) => {
    setEditingPreset((prev) => {
      const base = prev;
      const next = typeof updater === "function" ? updater(base) : updater;
      return next;
    });
  };

  const handleSaveEdit = () => {
    if (!editingPreset.name.trim()) {
      alert("프리셋 이름을 입력해주세요.");
      return;
    }
    const normalizedPreset = {
      ...editingPreset,
      schedules: editingPreset.schedules.map((s) => {
        const end = s.end;
        const isMidnight = end === 1440 || end === "24:00" || end === "00:00";

        return {
          ...s,
          isUntilMidnight: isMidnight,
        };
      }),
    };
    const timeValidation = isTimeOverlapping(normalizedPreset.schedules);
    if (!timeValidation.isValid) {
      toast.error(timeValidation.message);
      return;
    }
    const hasInvalidShiftId = normalizedPreset.schedules.some(
      (schedule) =>
        !schedule.shift_id ||
        schedule.shift_id === "" ||
        schedule.shift_id === undefined
    );
    if (hasInvalidShiftId) {
      toast.error("모든 시간 구간에 조업 구분을 선택해주세요.");
      return;
    }
    setEditingPreset(null);
    editMutation.mutate(
      {
        data: convertPresetsToDb(normalizedPreset, true),
        group_code,
        project_code,
      },
      {
        onSuccess: () => {
          toast.success("수정이 완료되었습니다.");
        },
        onError: (e) => {
          toast.error(e.response?.data?.message || "에러가 발생했습니다.");
        },
      }
    );
  };

  if (!preparedPreset) return null;
  return (
    <S.PresetForm elevation={3}>
      <div style={{ display: "flex", gap: "1rem" }}>
        <TextField
          sx={{ width: "50%" }}
          value={preparedPreset.name}
          onChange={(e) =>
            setEditingPreset({
              ...editingPreset,
              name: e.target.value,
            })
          }
          margin="normal"
          size="small"
        />
        <TextField
          sx={{ width: "50%" }}
          value={preparedPreset.description}
          onChange={(e) =>
            setEditingPreset({
              ...editingPreset,
              description: e.target.value,
            })
          }
          margin="normal"
          size="small"
        />
      </div>

      <TimeSlotList
        preset={preparedPreset}
        setPreset={setPresetFromTimeSlot}
        shiftsData={shiftsData}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "1rem",
        }}
      >
        <Button
          startIcon={<AddIcon />}
          onClick={() => handleAddSchedule(editingPreset, setEditingPreset)}
          color="primary"
        >
          시간 추가
        </Button>
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <Button
            startIcon={<CancelIcon />}
            onClick={() => setEditingPreset(null)}
          >
            취소
          </Button>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={handleSaveEdit}
          >
            저장
          </Button>
        </div>
      </div>
    </S.PresetForm>
  );
}

export default EditPresetForm;
